module.exports = "/images/oculus-12.jpg";